import React, { ReactElement } from "react";
import ConfirmDialog from "../../Common/Components/ConfirmDialog";
import whiteRoy from "../../../assets/img/icons/whiteRoy.svg";
import { removeSelectedIds } from "../DragnDrop/actions";
import NavigationPrompt from "react-router-navigation-prompt";
import { RootState } from "../../../store/index";
import { useSelector } from "react-redux";
import styled from "styled-components";

interface Props {}

function AbandonPopup({}: Props): ReactElement {
  const assetCount: number = useSelector((state: RootState) => state.dragDrop.selectedIds.length);
  const afterCancel = () => {
    //* things to do if user clicks on curate
  };

  const afterConfirm = () => {
    removeSelectedIds();
  };

  return (
    <NavigationPrompt
      afterCancel={afterCancel}
      afterConfirm={afterConfirm}
      when={(currentLocation, nextLocation) =>
        (!nextLocation || !nextLocation.pathname.startsWith(currentLocation.pathname)) && assetCount > 0
      }
    >
      {({ onConfirm, onCancel }) => (
        // <ConfirmNavigationModal when={true} onCancel={onCancel} onConfirm={onConfirm} />
        <Wrapper>
          <ConfirmDialog
            cancel="Leave"
            confirm="Curate"
            onConfirm={onCancel}
            onCancel={onConfirm}
            icon={whiteRoy}
            title={`If you leave this page, your ${assetCount} selected ${
              assetCount > 1 ? "articles" : "article"
            } will be lost`}
            titleQuestion=""
            description="We’re sending your email to your recipients and lists. It may take time for all recipients to receive the email, but sit tight — it won’t take long…"
          />
        </Wrapper>
      )}
    </NavigationPrompt>
  );
}

const Wrapper = styled.div`
  z-index: 17;
  height: 100vh;
  width: 100%;
  position: fixed;
`;

export default AbandonPopup;
